// FAQDetails.jsx
import { useParams } from 'react-router-dom';

const FAQDetails = () => {
  const { id } = useParams();
  return (
    <div className="min-h-screen bg-white p-4">
      <div className="flex justify-between items-center mb-4">
        <button>&larr;</button>
        <h2 className="font-bold">Receipt</h2>
        <div></div>
      </div>

      <h3 className="font-semibold text-lg mb-2">How to Share Receipt Via SMS?</h3>
      <div className="flex items-center gap-2 text-sm mb-4">
        <img src="https://i.pravatar.cc/32" className="rounded-full w-6 h-6" />
        <span>Balasundar</span>
        <span className="text-gray-400">Updated 23 May 2024 - 20:15</span>
      </div>

      <div className="bg-gray-100 p-4 rounded-lg text-sm space-y-2">
        <p><strong>Step 1:</strong> Click On 'Menu' On Upper Left Corner</p>
        <p><strong>Step 2:</strong> Click On 'Receipts'</p>
        <p><strong>Step 3:</strong> Choose The Dates And Click On The Receipt</p>
        <p><strong>Step 4:</strong> Click On 'SMS'</p>
        <p><strong>Step 5:</strong> Enter The Mobile Number</p>
        <p><strong>Step 6:</strong> Click 'Send'</p>
      </div>

      <h4 className="mt-6 font-semibold">Related Articles</h4>
      <div className="mt-2 space-y-2">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex justify-between items-center p-3 border rounded-lg text-sm">
            <span>Lorem Ipsum is simply dummy text?</span>
            <span className="bg-primary text-primary px-2 py-1 text-xs rounded-full">?</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQDetails;
